<template>
  <v-app style="background: none">
    <v-snackbar
      :color="snackBarColor"
      shaped
      top
      right
      v-model="displaySnackBar"
    >
      <span v-html="snackBarText"></span>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="displaySnackBar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-tour name="myTour" :steps="steps"></v-tour>
    <component :is="layout"> </component>
    <v-main>
      <transition name="slide-left" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-main>
    <footer>
      <cookie-law theme="dark-lime" buttonText="J'ai compris">
        <div slot="message">
          Pour faciliter votre visite et rendre l'expérience utilisateur aussi
          fluide que possible, ce site web utilise des 🍪. Pour plus
          d'informations
          <router-link to="/cookie-policy">cliquez ici</router-link>
        </div>
      </cookie-law>
    </footer>
  </v-app>
</template>

<script>
import CookieLaw from "vue-cookie-law";
import { EventBus } from "@/eventBus";

export default {
  name: "App",
  components: { CookieLaw },
  computed: {
    layout() {
      return (this.$route.meta.layout || "default") + "-layout";
    }
  },
  created: async function() {
    EventBus.$on("showSnackBar", data => {
      this.displaySnackBar = true;
      this.snackBarColor = data.type;
      this.snackBarText = data.message;
    });
  },
  mounted: function() {
    //this.$tours['myTour'].start()
  },
  data: () => ({
    displaySnackBar: false,
    snackBarText: "",
    snackBarColor: "success",
    steps: [
      {
        target: "#v-step-0", // We're using document.querySelector() under the hood
        header: {
          title: "Création"
        },
        content: `Là vous pouvez créer une nouvelle activité`
      },
      {
        target: "#v-step-1", // We're using document.querySelector() under the hood
        header: {
          title: "Menu"
        },
        content: `Là vous pouvez créer une nouvelle activité`
      },
      {
        target: "#v-step-2", // We're using document.querySelector() under the hood
        header: {
          title: "Création"
        },
        content: `Là vous pouvez créer une nouvelle activité`
      },
      {
        target: "#v-step-3", // We're using document.querySelector() under the hood
        header: {
          title: "Menu"
        },
        content: `Là vous pouvez créer une nouvelle activité`
      }
    ]
  })
};
</script>

<style>
.theme--light.v-application {
  //background-color: #eee !important;
}

.v-main__wrap {
  border-radius: 30px 0px 0px 30px;
  background-color: #f7f6fb;
}
</style>
